import Interceptors from './../Interceptors/Interceptors';

class Roles {
    constructor() {
        this.interceptors = new Interceptors();
    }

    async getRoles(data) {
        return this.interceptors.POST('roles/list', data);
    }

    async addRole(data) {
        return this.interceptors.POST('roles', data);
    }

    async updateRole(roleId, data) {
        return this.interceptors.PUT('roles/' + roleId, data);
    }

    async deleteRole(roleId) {
        return this.interceptors.DELETE('roles/' + roleId);
    }

    async getModules(data) {
        return this.interceptors.POST('roles/modules/list', data);
    }
}

export default Roles;